import { parseISO } from 'date-fns';

/** Format an amount in cents to a USD currency string (e.g. 5000 → "$50.00") */
export function formatCurrency(cents: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(cents / 100);
}

/**
 * Format a nullable ISO string / Date into a friendly date (e.g. "Aug 1, 2026").
 * Renders the calendar date in UTC so a midnight-UTC due date does not shift a day
 * backward in timezones behind UTC.
 */
export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return 'TBD';
  const d = typeof value === 'string' ? parseISO(value) : value;
  if (Number.isNaN(d.getTime())) return 'TBD';
  return new Intl.DateTimeFormat('en-US', {
    timeZone: 'UTC',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(d);
}
